import Alpine from "alpinejs";

// @ts-ignore
import intersect from "@alpinejs/intersect";

// @ts-ignore
import anchor from "@alpinejs/anchor";

// @ts-ignore
import mask from "@alpinejs/mask";

// Data Components
import "./data/carousel";
import "./data/dropdown";
import "./data/modal";
import "./data/form";
import "./data/popover";
import "./data/tabs";
import "./data/toggler";
import "./data/video";
import "./data/address-validation";
import "./data/nosto-social-gallery";
import "./data/banner";
import "./data/variant-selector";
import "./data/store-hours";
// Stores
import "./store/loyalty";
import "./store/cart";
import "./store/store-finder";

// Magic
import "./magic/store-config";

Alpine.plugin(intersect);
Alpine.plugin(anchor);
Alpine.plugin(mask);

Alpine.start();
